/**
 * Katanas in Action — Cover-flow carousel
 * 5 visible at a time, infinite loop, focus stays in center
 */
(function() {
  'use strict';
  
  function initKiaSection(section) {
    var sectionId = section.getAttribute('data-section-id');
    if (!sectionId) return;
    
    var modal = document.getElementById('kia-modal-' + sectionId);
    if (!modal) return;
    
    var stage = section.querySelector('.kia-stage');
    var prevBtn = section.querySelector('.kia-prev');
    var nextBtn = section.querySelector('.kia-next');
    var thumbs = Array.prototype.slice.call(section.querySelectorAll('.kia-thumb'));
    var pagination = section.querySelector('.kia-pagination');
    var modalVideo = modal.querySelector('.kia-modal-video');
    var modalClose = modal.querySelector('.kia-modal-close');
    
    if (!stage || thumbs.length === 0) return;
    
    var totalVideos = thumbs.length;
    var currentIndex = 0; // index of the focused video
    
    // Build pagination dots
    if (pagination) {
      pagination.innerHTML = '';
      for (var i = 0; i < totalVideos; i++) {
        var dot = document.createElement('span');
        dot.className = 'kia-pag-dot';
        dot.setAttribute('data-index', i);
        pagination.appendChild(dot);
      }
    }
    
    function updatePositions() {
      thumbs.forEach(function(thumb, i) {
        // Calculate the offset from current focus, with infinite wrapping
        var offset = i - currentIndex;
        // Normalize to shortest path (handle wrap-around)
        if (offset > totalVideos / 2) offset -= totalVideos;
        if (offset < -totalVideos / 2) offset += totalVideos;
        
        // Remove all position classes
        thumb.classList.remove(
          'kia-pos-focus',
          'kia-pos-near-left',
          'kia-pos-near-right',
          'kia-pos-far-left',
          'kia-pos-far-right',
          'kia-pos-hidden'
        );
        
        // Apply position class based on offset
        if (offset === 0) {
          thumb.classList.add('kia-pos-focus');
        } else if (offset === -1) {
          thumb.classList.add('kia-pos-near-left');
        } else if (offset === 1) {
          thumb.classList.add('kia-pos-near-right');
        } else if (offset === -2) {
          thumb.classList.add('kia-pos-far-left');
        } else if (offset === 2) {
          thumb.classList.add('kia-pos-far-right');
        } else {
          thumb.classList.add('kia-pos-hidden');
        }
      });
      
      // Update pagination
      if (pagination) {
        var dots = pagination.querySelectorAll('.kia-pag-dot');
        dots.forEach(function(dot, i) {
          if (i === currentIndex) {
            dot.classList.add('is-active');
          } else {
            dot.classList.remove('is-active');
          }
        });
      }
    }
    
    function goNext() {
      currentIndex = (currentIndex + 1) % totalVideos;
      updatePositions();
    }
    
    function goPrev() {
      currentIndex = (currentIndex - 1 + totalVideos) % totalVideos;
      updatePositions();
    }
    
    function goToIndex(targetIndex) {
      currentIndex = ((targetIndex % totalVideos) + totalVideos) % totalVideos;
      updatePositions();
    }
    
    // Set initial focus to the configured featured index (1-based in liquid)
    var initialFocus = parseInt(section.getAttribute('data-initial-focus') || '1', 10) - 1;
    if (initialFocus >= 0 && initialFocus < totalVideos) {
      currentIndex = initialFocus;
    }
    updatePositions();
    
    // Arrows
    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goPrev();
      });
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goNext();
      });
    }
    
    // Pagination dot click
    if (pagination) {
      pagination.addEventListener('click', function(e) {
        var dot = e.target.closest('.kia-pag-dot');
        if (!dot) return;
        var idx = parseInt(dot.getAttribute('data-index'), 10);
        if (!isNaN(idx)) goToIndex(idx);
      });
    }
    
    // Click on thumbs:
    // - Focus thumb → open modal
    // - Side thumb → make it focus (rotate to center)
    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function(e) {
        e.preventDefault();
        if (thumb.classList.contains('kia-pos-focus')) {
          // Open modal
          var videoUrl = thumb.getAttribute('data-video');
          if (!videoUrl) return;
          modalVideo.src = videoUrl;
          modal.classList.add('is-active');
          document.body.style.overflow = 'hidden';
          setTimeout(function() {
            var p = modalVideo.play();
            if (p && p.catch) p.catch(function() {});
          }, 100);
        } else {
          // Bring to center
          goToIndex(i);
        }
      });
    });
    
    // Modal close
    function closeModal() {
      modal.classList.remove('is-active');
      modalVideo.pause();
      modalVideo.src = '';
      document.body.style.overflow = '';
    }
    
    if (modalClose) {
      modalClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
    }
    
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });
    
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('is-active')) {
        closeModal();
      }
      // Arrow keys when modal closed
      if (!modal.classList.contains('is-active')) {
        if (e.key === 'ArrowLeft' && document.activeElement && section.contains(document.activeElement)) {
          goPrev();
        } else if (e.key === 'ArrowRight' && document.activeElement && section.contains(document.activeElement)) {
          goNext();
        }
      }
    });
  }
  
  function initAll() {
    var sections = document.querySelectorAll('.kia-section[data-section-id]');
    sections.forEach(initKiaSection);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  
  // Re-init on Shopify section render (theme editor)
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(e) {
      var section = e.target.querySelector('.kia-section[data-section-id]');
      if (section) initKiaSection(section);
    });
  }
})();
